export default __webpack_public_path__ + "static/media/ve.3c6a6ada.svg";